const SITE_DEPENDENCY_ATTRIBUTE = 'data-ws-site-dependency';

export default {
  SITE_DEPENDENCY_ATTRIBUTE,
};
